// Default warehouse location for each item type (#260). Mirrors DEFAULT_LOCATION_BY_ITEM_TYPE in
// backend/common/locations.py, which is the source of truth: change both together. Types not listed
// (PACKAGING, CONSUMABLE) have no default and the user chooses the location.
export const DEFAULT_LOCATION_BY_ITEM_TYPE = {
  INK: 'BT-001', // bodega de tintas (also where formulated inks go)
  RAW: 'BR-AMTTO-001', // materia prima / rollos
  FINISHED_GOOD: 'BPT-001', // producto terminado
};

// Finished goods are received in BPT-001 (producto terminado); the user can pick another location
export const FINISHED_GOODS_LOCATION = DEFAULT_LOCATION_BY_ITEM_TYPE.FINISHED_GOOD;

// Formulation orders produce ink, so they go to the ink warehouse
export const INK_LOCATION = DEFAULT_LOCATION_BY_ITEM_TYPE.INK;

const codeOf = (loc) => (typeof loc === 'string' ? loc : loc.location_code);

// `preferred` if it is one of the given locations, else the first one ('' when there are none).
// Locations come sorted by zone, so the first one is not necessarily the right warehouse.
export const preferredLocation = (locations, preferred) => {
  if (preferred && locations.some(loc => codeOf(loc) === preferred)) return preferred;
  return locations.length > 0 ? codeOf(locations[0]) : '';
};

// Empty when the list is empty lets the server pick the item's location
export const defaultReceiptLocation = (locations) => preferredLocation(locations, FINISHED_GOODS_LOCATION);

export const defaultLocationForItemType = (itemType) => DEFAULT_LOCATION_BY_ITEM_TYPE[itemType] || '';
